import isMobile from "is-mobile";
import { add, listen, qs, remove } from "@fluorescent/dom";
import { getStorage, setStorage } from "@/lib/storage";
import { createFocusTrap } from "focus-trap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

export default function Popup(container) {
  const focusTrap = createFocusTrap(container, {
    allowOutsideClick: false,
  });
  const { id, popupType, timeout } = container.dataset;
  const storageKey = `popup-${id}`;
  const ageVerifiedKey = `age-verified-${id}`;
  const ageIsVerified = Boolean(getStorage(ageVerifiedKey));

  let bodyLeave = () => {};
  const mouseleave = e => {
    if (!e.relatedTarget && !e.toElement && !window.Shopify.designMode) {
      showPopup();
      bodyLeave();
    }
  };

  const events = [];

  // Initialize popup based on type
  const popupTypes = {
    "age_popup": () => {
      const verifyBtn = qs("[data-verify-age]", container);
      if (verifyBtn) {
        events.push(
          listen([verifyBtn], "click", e => {
            e.preventDefault();
            hidePopup();
          })
        );
      }

      if (!ageIsVerified) {
        showPopup();
      }
    },
    "popup": () => {
      const closeBtn = qs("[data-close]", container);
      const overlay = qs("[data-overlay]", container);
      events.push(
        listen([closeBtn, overlay], "click", e => {
          e.preventDefault();
          hidePopup();
        })
      );

      events.push(
        listen(container, "keydown", ({ keyCode }) => {
          if (keyCode === 27) hidePopup();
        })
      );

      if (!getStorage(storageKey) && isMobile()) {
        setTimeout(() => showPopup(), parseInt(timeout));
      } else if (!getStorage(storageKey)) {
        bodyLeave = listen(document.body, "mouseout", mouseleave);
      }
    },
  };

  popupTypes[popupType]();

  function showPopup() {
    add(container, "visible");

    if (popupType === "age_popup") {
      disableBodyScroll(container);
      focusTrap.activate();
    }
  }

  function hidePopup() {
    setStorage(storageKey, JSON.stringify(new Date()));
    remove(container, "visible");

    if (popupType === "age_popup") {
      setStorage(ageVerifiedKey, JSON.stringify(new Date()));
      setTimeout(() => {
        focusTrap.deactivate();
        enableBodyScroll(container);
      }, 330);
    }
  }

  function unload() {
    bodyLeave();
    events.forEach(unsubscribe => unsubscribe());
    if (popupType === "age_popup") {
      focusTrap.deactivate();
      enableBodyScroll(container);
    }
  }

  return { unload, showPopup, hidePopup };
}
